import { TDraftAssessment } from '../types';

type TSectionId = keyof TDraftAssessment['sections'];
type TItemId = keyof TDraftAssessment['sections'][TSectionId]['items'];
type TItem = TDraftAssessment['sections'][TSectionId]['items'][TItemId];

export const findAssessmentItem = (
  assessment: TDraftAssessment,
  itemId: TItemId,
): TItem | undefined => {
  const sections = assessment ? Object.values(assessment.sections) : undefined;
  const section = sections?.find((s) => itemId in s.items);
  const item = section?.items?.[itemId];

  return item;
};
